import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { CloserSyncInstruction } from '@models/mortgages/closer-sync-instruction';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface CloserSyncInstructionParams {
	transactionId: string;
}

@Injectable({
	providedIn: 'root',
})
export class CloserSyncInstructionRepoService extends Repo<
	CloserSyncInstruction,
	CloserSyncInstructionParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	GetCollectionPath(pathParam: CloserSyncInstructionParams): string {
		return CollectionPaths.business_mortgagesV2_Instructions(
			this.businessId,
			pathParam.transactionId,
		);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
